module.exports = __webpack_public_path__ + "static/media/img_Benchmarking205.b655b82d.png";